'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Analytics = require('../global/analytics');
var cookieHelper = require('../helpers/cookie-helper');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e['default'] : e; }

var Analytics__default = /*#__PURE__*/_interopDefaultLegacy(Analytics);
var cookieHelper__default = /*#__PURE__*/_interopDefaultLegacy(cookieHelper);

const GA_CATEGORY = 'Cookies Notice';

function CookiesNotice() {
  this.el = document.querySelector('.cookies-notice');
  this.cookieName = 'eu_cookies_acknowledged';
  this.setDismissedCookieNotice = this.setDismissedCookieNotice.bind(this);
  this._onDismissBtnClick = this._onDismissBtnClick.bind(this);

  if (!this.el || this.hasDismissedCookieNotice()) {
    return;
  }

  this.dismissBtn = this.el.querySelector('.js-dismiss-btn');
  this.dismissBtn.addEventListener('click', this._onDismissBtnClick);
  this.el.classList.add('js-is-active');
  Analytics__default.track(GA_CATEGORY, 'displayed');
}

CookiesNotice.prototype.hasDismissedCookieNotice = function () {
  return Boolean(cookieHelper__default.get(this.cookieName));
};

CookiesNotice.prototype.setDismissedCookieNotice = function () {
  const oneYearFromNowDate = new Date(new Date().setYear(new Date().getFullYear() + 1));
  return cookieHelper__default.set(this.cookieName, 1, {
    expires: oneYearFromNowDate,
    path: '/'
  });
};

CookiesNotice.prototype._onDismissBtnClick = function () {
  this.setDismissedCookieNotice();
  this.el.classList.remove('js-is-active');
  Analytics__default.track(GA_CATEGORY, 'dismissed');
};

exports.default = CookiesNotice;
